import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import { clearToken } from '../../../shared/lib/token';
import { sessionLoggedOut } from '../../session/model/actions';
import type { Region, User } from './types';

interface SessionState {
    user: User | null;
    regions: Region[];
}

const initialState: SessionState = {
    user: null,
    regions: [],
};

export const sessionSlice = createSlice({
    name: 'session',
    initialState,
    reducers: {
        setUser: (state, action: PayloadAction<User>) => {
            state.user = action.payload;
        },
        setRegions: (state, action: PayloadAction<Region[]>) => {
            state.regions = action.payload;
        },
    },
    extraReducers: (builder) => {
        builder.addCase(sessionLoggedOut, (state) => {
            clearToken();
            state.user = null;
            state.regions = [];
        });
    },
    selectors: {
        selectUser: (state) => state.user,
        selectIsAuthenticated: (state) => state.user !== null,
        selectRegions: (state) => state.regions,
    },
});

export const { setUser, setRegions } = sessionSlice.actions;
export const { selectUser, selectIsAuthenticated, selectRegions } = sessionSlice.selectors;
export const sessionReducer = sessionSlice.reducer;